import styled, {css} from 'styled-components'
import {ifProp} from 'styled-tools'

/**
 * Flex components
 */
export const Flex = styled.div<{
    direction?: 'row' | 'column'
    justify?: string
    align?: string
    wrap?: 'nowrap' | 'wrap' | 'wrap-reverse'
    sm?: boolean

}>`
    display: flex;
    flex-direction: ${({direction = 'row'}) => direction};
    justify-content: ${({justify = 'flex-start'}) => justify};
    align-items: ${({align = 'stretch'}) => align};
    flex-wrap: ${({wrap = 'nowrap'}) => wrap};

    ${ifProp(
            'sm',
            css`
                ${({theme}: { theme: any }) => theme.breakpoints.down('md')} {
                    flex-direction: column;
                }
            `
    )}
`

/**
 * Grid components
 */

interface GridProps {
    $columns?: string;
    $rows?: string;
    $gap?: string;
    $sm?: boolean;
    $align?: string;
    $justify?: string;
    $padding?: string;
}

export const Grid = styled.div<GridProps>`
    display: grid;
    grid-template-columns: ${({ $columns = "1fr" }) => $columns};
    grid-template-rows: ${({ $rows = "auto" }) => $rows};
    align-items: ${({ $align = "stretch" }) => $align};
    justify-items: ${({ $justify = "stretch" }) => $justify};
    padding: ${({ $padding = "0" }) => $padding};

    ${({ theme, $gap }: {theme: any, $gap?: any}) => css`
    gap: ${$gap || "0"};

    ${!$gap &&
    css`
      ${theme?.breakpoints.down("sm")} {
        gap: 8px;
      }
      ${theme?.breakpoints.up("lg")} {
        gap: 16px;
      }
      ${theme?.breakpoints.up("xl")} {
        gap: 24px;
      }
    `}
  `}

    ${ifProp(
            "$sm",
            css`
                ${({ theme }: {theme:any}) => theme?.breakpoints.down("md")} {
                    display: flex;
                    flex-direction: column;
                    margin: 0 12%;
                }
            `
    )}
`;



/**
 * Col (basic grid/flex column wrapper)
 */

type ResponsiveSpan = {
    $span?: number
    $sm?: number
    $md?: number
    $lg?: number
    $xl?: number
}

export const Col = styled.div.attrs((props: any) => ({
    className: `col-span-${props?.$span || 1}`,
}))<ResponsiveSpan>`
    ${({$span}) =>
            $span &&
            css`
                grid-column: span ${$span};
            `}

    ${({$sm, theme}) =>
            $sm &&
            css`
                ${({theme}: { theme: any }) => theme.breakpoints.down('sm')} {
                    grid-column: span ${$sm};
                }
            `}

    ${({$md, theme}) =>
            $md &&
            css`
                ${({theme}: { theme: any }) => theme.breakpoints.down('md')} {
                    grid-column: span ${$md};
                }
            `}

    ${({$lg, theme}) =>
            $lg &&
            css`
                ${({theme}: { theme: any }) => theme.breakpoints.down('lg')} {
                    grid-column: span ${$lg};
                }
            `}

    ${({$xl, theme}) =>
            $xl &&
            css`
                ${({theme}: { theme: any }) => theme.breakpoints.down('xl')} {
                    grid-column: span ${$xl};
                }
            `}
`;
